import { motion } from "framer-motion";
import React, { useEffect, useMemo, useState } from "react";
import { variants } from "../../shared/variants";
import { useWizard } from "react-use-wizard";
import { useDispatch, useSelector } from "react-redux";
import { useMixpanel } from "react-mixpanel-browser";
import { toast } from "react-toastify";
import { makePostRequest } from "../../services/apiHandler";
import { stepActions } from "../../store/Steps";
import * as GrIcons from "react-icons/gr";
import Loader from "../../shared/loader/Loader";
import CurrencyFormatter from "../../shared/currency-formatter";
import { isStandardInurance } from "../../shared/currency-formatter/utils";
import { useTranslation } from "react-i18next";

function Promotions({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const PROMO_STORAGE_KEY = "promoCode";
  const tenantCreds = useSelector((state: any) => state.tenantCreds);
  const isStandard = useMemo(() => isStandardInurance(tenantCreds?.domain), [tenantCreds?.domain]);
  const [processingPromo, setProcessingPromo] = useState(false);
  const [quoteInfor, setQuoteInfor] = useState({
    code: "",
    discount: 0,
    payable: 0,
    qid: "",
    product: "",
    isFinanced: false,
    endtimestamp: 0,
    _date: {},
    _timestamp: 0,
    _id: "",
  });
  const mixpanel = useMixpanel();

  let quote = JSON.parse(sessionStorage.getItem("quote")!);

  const [promoInfo, setPromoInfor] = useState({
    code: "",
  });

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    setPromoInfor((prevState) => ({
      ...prevState,
      code: value,
    }));
    sessionStorage.setItem(PROMO_STORAGE_KEY, value);
  };

  const calculatePromo = async () => {
    if (!promoInfo.code) {
      toast.error(t("promo.noCodeError"));
      return;
    }
    setProcessingPromo(true);
    let body = {
      code: promoInfo.code,
      id: quote?._id,
      insurer: quote?.insurer,
      payable: quote?.amount,
      product: "insurance_travel",
    };
    const apiResponse: IApiResponse = await makePostRequest(
      `${process.env.REACT_APP_UPXSELL_API_URL}/getpromo`,
      body,
      {
        SKEY: sessionStorage.getItem("SKEY")!,
        ModuleID: tenantCreds?.moduleId,
        apiKey: tenantCreds?.moduleId,
      },
    );
    try {
      setProcessingPromo(false);
      if (apiResponse.Status == 200) {
        toast.success(apiResponse.Message);
        setQuoteInfor(apiResponse.Payload);
        quote.amount = quoteInfor.discount;
      } else if (apiResponse.Status == 543) {
      } else {
        toast.error(apiResponse.Payload);
      }
    } catch (error: any) {
      setProcessingPromo(false);
      toast.error(error);
    }
  };

  const proceed = () => {
    sessionStorage.setItem("quote", JSON.stringify(quote));

    if (isStandard) {
      sessionStorage.setItem("payment-screen", "payment-chapa");
      setCurrentScreen("payment-chapa");
      return
    }

    if (quote.amount < 10000) {
      sessionStorage.setItem("payment-screen", "payment-method");
      setCurrentScreen("payment-method");
    } else {
      sessionStorage.setItem("payment-screen", "payment-opt");
      setCurrentScreen("payment-opt");
    }
  };

  useEffect(() => {
    const storedPromoCode = sessionStorage.getItem(PROMO_STORAGE_KEY);
    const promoCode = storedPromoCode || "";

    if (promoCode) {
      setPromoInfor({
        code: promoCode,
      });
    }

    if (mixpanel.config.token) {
    }
    mixpanel.track("PageView", {
      pageName: "Travel|Promotions",
    });
    // refreshToken();
  }, []);

  return (
    <motion.div
      variants={variants}
      initial="enter"
      animate="center"
      exit={{ opacity: 0 }}
      className="steps-conatiner2"
    >
      <div className="personal-information">
        <div className="reg-title text-center">
          <span className="reg-title-primary">{t("promo.title")}</span>
        </div>
        <div className="row ">
          <div className="col-md-4 promotion">
            <div className="promo-container mt-4">
              <div className="promo-title">{t("promo.gotCode")}</div>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  id="promotion-code"
                  placeholder={t("promo.placeholder")}
                  onChange={handleInputChange}
                  name="code"
                  value={promoInfo.code}
                />
                {processingPromo ? (
                  <Loader />
                ) : (
                  <span
                    className="input-group-text promo-action-btn"
                    id="inputGroup-sizing-default"
                    onClick={() => calculatePromo()}
                  >
                    {t("promo.apply")}
                  </span>
                )}
              </div>
            </div>
            <div className="promo-container mt-4">
              <div className="promo-breakdown">
                <div className="premium-amount-key">{t("promo.subtotal")}</div>
                <div className="premium-amount-value">
                  <CurrencyFormatter
                    value={quote?.premium?.payable?.toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix
                  />
                </div>
              </div>
              <div className="promo-breakdown">
                <div className="premium-amount-key">{t("promo.discount")}</div>
                <div className="premium-amount-value">
                  {quoteInfor?.discount ? (
                    <CurrencyFormatter
                      value={
                        quoteInfor?.discount
                          ? quoteInfor?.discount?.toFixed(2)
                          : 0
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix
                    />
                  ) : (
                    0
                  )}
                </div>
              </div>
              <div className="promo-breakdown grand-total">
                <div className="premium-amount">{t("promo.grandTotal")}</div>
                <div className="premium-amount">
                  {" "}
                  <CurrencyFormatter
                    value={
                      quoteInfor?.payable
                        ? quoteInfor?.payable?.toFixed(2)
                        : quote?.amount?.toFixed(2)
                    }
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-around align-items-center ms-3 me-2 mt-5">
        <div onClick={() => proceed()}>
          <button className="next-btn">
            {" "}
            <span>{t("promo.proceedToPay")}</span>{" "}
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default Promotions;
